const $ = jQuery.noConflict();

class Accordions {
    constructor(trigger) {
        this.trigger = $(trigger);
    }

    init() {
        this.trigger.on('click', this.toggleAccordion);
    }

    toggleAccordion() {
        const parent = $(this).parent();
        if (parent.hasClass('active')) {
            parent.removeClass('active content-visible');
            $(this).next().stop().slideUp(200);
        } else {
            parent.addClass('active');
            $(this).next().stop().slideDown(200);
            setTimeout(() => {
                parent.addClass('content-visible');
            }, 100);
        }
    }
}

export default new Accordions('.single-accordion__title');
